import * as actionTypes from './actionTypes';

export const getPaymentOptions = (roomId, serviceId, timestamp) => ({
    type: actionTypes.GET_PAYMENT_OPTIONS,
    roomId: roomId,
    serviceId: serviceId,
    timestamp: timestamp
});

export const getPaymentOptionsSucceeded = paymentOptions => ({
    type: actionTypes.GET_PAYMENT_OPTIONS_SUCCEEDED,
    paymentOptions: paymentOptions
});

export const getPaymentOptionsFailed = message => ({
    type: actionTypes.GET_PAYMENT_OPTIONS_FAILED,
    message
});

export const confirmPayment = ({ roomId, serviceId, timestamp, onlinePayment, paymentType, idealBankId, bookingID, history, url }) => ({
    type: actionTypes.CONFIRM_PAYMENT,
    payload: {
        roomId,
        serviceId,
        timestamp,
        onlinePayment,
        paymentType,
        idealBankId,
        bookingID,
        history,
        url
    }
});
export const confirmPaymentSucceeded = ({ id, paymentType, onlinePayment }) => ({
    type: actionTypes.CONFIRM_PAYMENT_SUCCEEDED,
    payload: {
        id,
        onlinePayment,
        paymentType
    }
});

export const cancelPayment = id => ({
    type: actionTypes.CANCEL_PAYMENT,
    id
});

export const checkPaymentStatus = id => ({
    type: actionTypes.CHECK_PAYMENT_STATUS,
    id
});

export const updatePaymentStatus = status => ({
    type: actionTypes.UPDATE_PAYMENT_STATUS,
    status
});

export const confirmPaymentError = error => ({
    type: actionTypes.CONFIRM_PAYMENT_ERROR,
    error,
});

export const setPaymentUrl = paymentUrl => ({
    type: actionTypes.SET_PAYMENT_URL,
    paymentUrl,
})
